/* eslint-disable */

import Push from 'push.js';
import alreadyReviewPopup from '@/components/private/already-review-popup/';
import appointmentMakeFav from '@/components/private/appointment-make-favourite-popup';
import {bus} from '@/main';
import commonSocketConnectMethod from "@/services/commonSocket";
import feedbackForm from '@/components/private/rating-review-popup';
import { mapGetters } from 'vuex';
import moment from 'moment';
import pendingReviewBlurbPopup from '@/components/private/review-pending-blurb-popup';
import remarksListPopup from '@/components/private/remarks-list-pooup';
import updateAppointmentDetails from '@/components/private/update-appointment-details-modal';

export default {
  name: 'appointment',
  components: {
    'update-appointment-details' : updateAppointmentDetails,
    'appointment-favourite' : appointmentMakeFav,
    'remarks-list' : remarksListPopup,
    'feedback-form' : feedbackForm,
    'pending-review':pendingReviewBlurbPopup,
    'already-review-popup' : alreadyReviewPopup
  },
  props: [],
  data () {
    return {
      appointmentList:null,
      appointmentListRslt:[],
      updateAppointmentDetailModal:false,
      updateAppointmentId:'',
      appointmentInfoForFav:null,
      appointmentFavModal:false,
      remarksListPopupState:false,
      remarksListPopupData:null,
      feedbackState:false,
      doctorId:'',
      pendingReviewPopupState:false,
      alreadyReviewPopupState:false,
      callTextState: false,
      selfUserId:"",
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'appointmentListGetters'
    ]),
    getAppointmentListMethod() {
       this.appointmentList = this.$store.getters.appointmentListGetters.data;
       return;
    },
    setIntialStatus() {
      if (this.appointmentList) {
        this.appointmentListRslt = this.appointmentList.results;
      }
      return;
    },
  },
  mounted () {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID');
      this.selfUserInfo = JSON.parse(localStorage.getItem('LoginedUserInfo'));
    }
    this.getAppointmentListMethod;
    this.setIntialStatus;
    bus.$on('alreadyReviewPopupBus', (data) => {
      this.alreadyReviewPopupState = data;
    });
    bus.$on('pendingReviewPopupBus', (data) => {
      this.pendingReviewPopupState = data;
    });
    bus.$on('updateAppointmentDetailModalBus', (data) => {
      this.updateAppointmentDetailModal = data;
    });
    bus.$on('appointmentFavModalBus', (data) => {
      this.appointmentFavModal = data;
    });
    bus.$on('remarksListPopupStateBus', (data) => {
      this.remarksListPopupState = data;
    });
    bus.$on('feedbackStateBus', (data) => {
      this.feedbackState = data;
    });
    // Update Message Notification Event Listener
    bus.$on('updateMessageNotification', (data) => {
      this.handleChatRoomNotification(data);
    });
  },
  methods: {
    handleChatRoomNotification(data) {
      let targetUserChatRoom = this.appointmentList.find(item => item.chat_room_id === data.chatRoomId);

      if (targetUserChatRoom) {
        this.handleNotification(targetUserChatRoom, data);
      }
    },
    handleNotification(room, data) {
      const unreadByRoom = data.unreadByRoom;
      const countForSpecificId = unreadByRoom[room.chat_room_id];
      if (countForSpecificId > 0) {
        if (Push.Permission.has()) {
          Push.create(data.senderName, {
            body: data.message,
            timeout: 4000,
            onClick: function () {
              window.focus();
              this.close();
            }
          });
          room.unread_count = countForSpecificId;
        } else {
          room.unread_count = countForSpecificId;
          // this.playSound(audioPlay); // Assuming playSound is a method of 'this'
        }
      }
    },
    alreadyReviewPopupMethod(){
      this.alreadyReviewPopupState = true;
      document.body.classList.add('popup_open_body');
    },
    openPendingReviewPopupMethod(){
      this.pendingReviewPopupState = true;
      document.body.classList.add('popup_open_body');
    },
    feedbackPopupOpenMethod(id){
      this.feedbackState = true;
      this.doctorId = id;
      document.body.classList.add('popup_open_body');
    },
    remarkPopupOpenMethod(data){
      this.remarksListPopupData = data;
      this.remarksListPopupState = true;
      document.body.classList.add('popup_open_body');
    },
    rescheduleAppointmentCheckMethod(date){
      var currentLocalDate = moment().format('MM D YYYY');
      var startDateCheck = moment(date).format('MM D YYYY');
      if(startDateCheck > currentLocalDate){
        return true;
      }else{
        return false;
      }
    },
    updateAppointmentDetailModalMethod(id){
      document.body.classList.add('popup_open_body');
      this.updateAppointmentDetailModal = true;
      this.updateAppointmentId = id;
    },
    makeAppointmentFavouriteMethod(data){
      document.body.classList.add('popup_open_body');
      this.appointmentInfoForFav = data;
      this.appointmentFavModal = true;
    },
    /*
     * This Will Video Call Request Function
    */
    videoCallRequestFun(callerId, roomId) {
      this.callTextState = true;
      let callerFullName = this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name;
      commonSocketConnectMethod.emit({
        callerName: callerFullName,
        type: "videoCalling",
        callerID: this.selfUserId,
        targetId: callerId,
        roomId: roomId
      });
      commonSocketConnectMethod.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      commonSocketConnectMethod.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      commonSocketConnectMethod.$on('videoCallAlertPopupClosed', this.notrecievedCall);
      commonSocketConnectMethod.$on('autoMissedCallEvent', this.autoMissedCall);
    },
    getAnswerOfVideoCall(getAnswerData) {
      if (this.selfUserId == getAnswerData.targetId) {
        this.$router.push('/video/conference/#' + getAnswerData.roomId);
      }
      this.callTextState = false;
    },
    getDeclinedOfVideoCall() {
      this.callTextState = false;
    },
    notrecievedCall() {
      this.callTextState = false;
    },
    autoMissedCall() {
      this.callTextState = false;
    },
  },
  watch:{
    getAppointmentListMethod() {
      return this.$store.getters.appointmentListGetters;
    },
    setIntialStatus() {
      if (this.appointmentList) {
        this.appointmentListRslt = this.appointmentList.results;
      }
      return;
    },
  }
}